module.exports = __webpack_public_path__ + "assets/img/kefu.f57f415c.png";